<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Brand:">
              <b-v-select
                v-model="formFilters.brandId"
                :searchable="true"
                :options="brandsFilter"
              />
            </b-form-group>

            <b-form-group label="Warehouse:">
              <b-v-select
                v-model="formFilters.warehouseId"
                :searchable="true"
                :options="warehousesFilter"
              />
            </b-form-group>

            <b-form-group label="Tracking Number:">
              <b-form-input v-model="formFilters.trackingNumber" />
            </b-form-group>

            <b-form-group label="Carrier:">
              <b-form-input v-model="formFilters.carrier" />
            </b-form-group>

            <b-form-group label="Processing System:">
              <b-form-select v-model="formFilters.processingSystem" :options="processingSystemOpts">
              </b-form-select>
            </b-form-group>

            <b-form-group label="Order ID:">
              <b-form-input v-model="formFilters.orderId" />
            </b-form-group>

            <b-form-group label="Label Type:">
              <b-form-select v-model="formFilters.isReturnLabel" :options="labelTypeOpts">
              </b-form-select>
            </b-form-group>

            <b-form-group label="Status:">
              <b-form-select v-model="formFilters.isVoided" :options="labelStatusOpts">
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="From Ship Date:"
              description="From Date must be before To Date"
            >
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.shipDateFrom"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="shipDateFrom"
              />
            </b-form-group>
            <b-form-group class="border-bottom mb-1 pb-2" label="To Ship Date:">
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.shipDateTo"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="shipDateTo"
              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Shipment Labels
            </h1>
            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadOrderItems">
              <template v-slot:filterWrap(quickView)>
              </template>
              <template v-slot:filterWrap(brandId)="data">
                <span class="badge badge-primary mr-2">
                    <b>Brand: </b>
                    <span><span
                        v-if="myBrands && myBrands.find(a => a.id == data.item)"
                        >{{ myBrands.find(a => a.id == data.item).name }}</span
                      >
                      <span v-else>-</span></span>
                      <span
                        class="fa fa-times fa-1x ml-2"
                        @click="
                          resetFilterWithKey('brandId');
                          loadOrderItems();
                        "
                    ></span>
                </span>
              </template>
              <template v-slot:filterWrap(warehouseId)="data">
                <span class="badge badge-info mr-2">
                    <b>Warehouse: </b>
                    <span><span
                        v-if="myWarehouses && myWarehouses.find(a => a.id == data.item)"
                        >{{ myWarehouses.find(a => a.id == data.item).name }}</span
                      >
                      <span v-else>-</span></span>
                      <span
                        class="fa fa-times fa-1x ml-2"
                        @click="
                          resetFilterWithKey('warehouseId');
                          loadOrderItems();
                        "
                    ></span>
                </span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(brandId)="data">
        <span
          v-if="myBrands && myBrands.find(a => a.id == data.item.brandId)"
          >{{ myBrands.find(a => a.id == data.item.brandId).name }}</span
        >
        <span v-else>-</span>
      </template>
      
      <template v-slot:cell(warehouseId)="data">
        <span
          v-if="myWarehouses && myWarehouses.find(a => a.id == data.item.warehouseId)"
          >{{ myWarehouses.find(a => a.id == data.item.warehouseId).name }}</span
        >
        <span v-else>-</span>
      </template>

      <template v-slot:cell(trackingNumber)="data">
        <div>
          <span v-if="data.item.trackingUrl">
            <a target="_blank"
              class="badge"
              :class="{
                'badge-danger': data.item.isReturnLabel,
                'badge-secondary': !data.item.isReturnLabel
              }"
              :href="data.item.trackingUrl">{{ data.item.trackingNumber }}</a>
          </span>
          <span v-else-if="data.item.trackingNumber">
            <a :href="'https://t.17track.net/en#nums=' + data.item.trackingNumber"
              target="_blank"
              class="badge"
              :class="{
                'badge-danger': data.item.isReturnLabel,
                'badge-secondary': !data.item.isReturnLabel
              }"
              >{{ data.item.trackingNumber }}</a>
          </span>
          <span v-else>
            <span>{{ data.item.trackingNumber }}</span>
          </span>
        </div>
      </template>

      <template v-slot:cell(labelType)="data">
        <span class="badge" :class="{
          'badge-danger': data.item.isReturnLabel,
          'badge-success': !data.item.isReturnLabel
        }">
          {{ data.item.isReturnLabel ? 'Return' : 'Outbound' }}
        </span>
      </template>

      <template v-slot:cell(status)="data">
        <span class="badge" :class="{
          'badge-danger': data.item.isVoided,
          'badge-success': !data.item.isVoided
        }">
          {{ data.item.isVoided ? 'Voided' : 'Active' }}
        </span>
      </template>

      <template v-slot:cell(labelCost)="data">
        <div>
          <div class="small text-muted">Client: ${{ (data.item.clientLabelCost || 0).toFixed(2) }}</div>
          <div class="small">Actual: ${{ (data.item.actualLabelCost || 0).toFixed(2) }}</div>
        </div>
      </template>

      <template v-slot:cell(orderId)="data">
        <router-link
          v-if="data.item.orderId"
          class="badge badge-warning"
          :to="{
            name: 'Common.OrderDetails',
            query: { id: data.item.orderId }
          }"
        >
          Open Order
        </router-link>
        <span v-else>-</span>
      </template>

      <template v-slot:cell(actions)="data">
        <div class="btn-group" role="group">
          <b-button
            size="sm"
            variant="outline-primary"
            @click="downloadLabel(data.item)"
            :disabled="!data.item.id"
            title="Download label"
          >
            <i class="fa fa-download"></i>
          </b-button>
          <b-button
            size="sm"
            variant="outline-danger"
            @click="voidLabel(data.item)"
            :disabled="!data.item.id || data.item.isVoided"
            title="Void label"
          >
            <i class="fa fa-ban"></i>
          </b-button>
        </div>
      </template>

      <template v-slot:cell(shipDate)="data">
        <span v-if="data.item.shipDate">{{
          data.item.shipDate | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMM Do, h:mm a')
        }}</span>
        <span v-else>-</span>
      </template>

      <template v-slot:cell(createDateTimeUtc)="data">
        <span>{{
          data.item.createDateTimeUtc | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMM Do, h:mm a')
        }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing, ActiveFiltersCard } from '@/views/components/custom';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  name: 'Storefronts.ShipmentLabels.Index',
  mixins: [crudMixinGen('shipmentLabels'), myCommonDataMixin],
  components: {
    TableListing,
    ActiveFiltersCard
  },
  computed: {
    brandsFilter() {
      return this.myBrands ? [
        { text: 'All', value: '' },
        ...this.myBrands.map(brand => ({ text: brand.name, value: brand.id }))
      ] : [{ text: 'All', value: '' }];
    },
    warehousesFilter() {
      return this.myWarehouses ? [
        { text: 'All', value: '' },
        ...this.myWarehouses.map(warehouse => ({ text: warehouse.name, value: warehouse.id }))
      ] : [{ text: 'All', value: '' }];
    }
  },

  data: () => ({
    fields: [
      { key: 'brandId', label: 'Brand', sortable: false },
      { key: 'warehouseId', label: 'Warehouse', sortable: false },
      { key: 'trackingNumber', label: 'Tracking Number', sortable: false },
      { key: 'carrier', label: 'Carrier', sortable: false },
      { key: 'service', label: 'Service', sortable: false },
      { key: 'processingSystem', label: 'System', sortable: false },
      { key: 'labelType', label: 'Type', sortable: false },
      { key: 'status', label: 'Status', sortable: false },
      //{ key: 'labelCost', label: 'Cost', sortable: false },
      { key: 'orderId', label: 'Order', sortable: false },
      { key: 'shipDate', label: 'Ship Date', sortable: false },
      { key: 'createDateTimeUtc', label: 'Created', sortable: false },
      { key: 'actions', label: 'Actions', sortable: false }
    ],
    processingSystemOpts: [
      { text: 'All', value: '' },
      { text: 'DeutschePostDHL', value: 'Deutsche Post DHL' },
      { text: 'ShipEngine', value: 'ShipEngine' },
      { text: 'TechShip', value: 'TechShip' },
      { text: 'UPS', value: 'UPS' },
      { text: 'eHub', value: 'eHub' },
      { text: 'GlobalAccess', value: 'GlobalAccess' }
    ],
    labelTypeOpts: [
      { text: 'All', value: null },
      { text: 'Outbound', value: false },
      { text: 'Return', value: true }
    ],
    labelStatusOpts: [
      { text: 'All', value: null },
      { text: 'Active', value: false },
      { text: 'Voided', value: true }
    ]
  }),
  
  mounted() {
    this.loadItems();
  },

  methods: {
    downloadLabel(label) {
      window.open('/download/shipment-label/' + label.id, '_blank');
    },
    voidLabel(label) {
      this.$swal({
        title: 'Void label?',
        text: 'This will cancel the label with the carrier. This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, void it!'
      }).then(result => {
        if (result.value) {
          this.$http.delete('/api/common/shipment-labels/' + label.id)
            .then(response => {
              if (response.data && response.data.success) {
                label.isVoided = true;
                this.$swal('Voided!', 'The label has been voided.', 'success');
              } else {
                this.$swal({ title: 'Error!', text: (response.data && response.data.message) || 'Failed to void label', icon: 'error' });
              }
            })
            .catch(error => {
              this.$swal({ title: 'Error!', text: (error.response && error.response.data && error.response.data.errorMessage) || 'Failed to void label', icon: 'error' });
            });
        }
      });
    }
  }
};
</script>